<template>
  <div class="px-4 pb-20 pt-[4.25rem]">
    <!-- ログインフォーム -->
    <div class="co-container-xs mx-auto !max-w-[600px] bg-white shadow-[0_0_4px_rgba(51,51,51,0.2)]">
      <div class="co-display-8 border-b border-dotted border-b-[#ccc] px-5 py-2">
        受講生ログイン
      </div>
      <form
        class="px-5 py-8"
        @submit.prevent
      >
        <!-- メールアドレス -->
        <div class="mx-1">
          <input
            v-model="email"
            placeholder="メールアドレス"
            type="email"
            required
            class="input w-full border-2 border-co-gray-300"
          >
          <span
            v-if="errors.email && errors.email.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ errors.email.join(', ') }}
          </span>
        </div>
        <!-- パスワード -->
        <div class="mx-1 pt-3">
          <input
            v-model="password"
            placeholder="パスワード"
            type="password"
            required
            class="input w-full border-2 border-co-gray-300"
          >
        </div>
        <!-- ボタン -->
        <div class="pt-5 text-right">
          <button
            class="co-btn-submit co-btn-small ya-te-btn-red !w-[8.875rem]"
            @click="onSubmit(true)"
          >
            ログインする
          </button>
          <span
            v-if="applicationErrors.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ applicationErrors.join(", ") }}
          </span>
        </div>
      </form>
    </div>
    <!-- パスワードを忘れた方はこちら -->
    <div class="co-display-14 mt-4 text-center text-co-gray-500">
      <FontAwesomeIcon
        :icon="faCircleInfo"
        class="fa-fw mr-2 inline size-3"
      />LINEヤフーテックアカデミーを受講される方、無料相談を利用される方のみがログイン可能です。
    </div>
    <a
      href="/ly/users/passwords"
      class="co-display-14 block text-center"
    >
      パスワードを忘れた方はこちら
    </a>
  </div>
</template>

<script lang="ts">
import { postSession } from '~/utility/fetchAPI'
import validateSessionForm from '~/utility/validation/validateSessionForm'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleInfo } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface TextValue {
  value: number
  text: string
}

interface Data {
  email: string
  password: string
  errors: any
  applicationErrors: string[]
}

interface Methods {
  onSubmit: () => void
}

interface Computed {
  usageTypeOptions: TextValue[]
}

const options = {
  async setup() {
    return {
      faCircleInfo,
    }
  },
  props: {},
  data() {
    return {
      email: '',
      password: '',
      errors: [],
      applicationErrors: [],
    }
  },
  mounted() {},
  methods: {
    onSubmit() {
      const body: any = {
        session: {
          email: this.email,
          password: this.password,
        },
      }
      validateSessionForm(body)
        .then(() => {
          postSession(this.$api, body)
            .then(() => {
              window.location.href = `/my`
            })
            .catch((errors: any) => {
              this.applicationErrors = errors?.response?.data?.errors
            })
        })
        .catch((errors: any) => {
          this.errors = errors
        })
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');

.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
